export default __webpack_public_path__ + "static/media/be.fb381534.svg";